export default "__VITE_ASSET__CkauyVmE__"